<template>
    <div class="retention">
        <PageTitle icon="fa fa-clone" main="Registro" sub="Retenção" />
        <b-form
            v-show="mode === 'save' || mode === 'remove' || mode === 'read'"
        >
            <input id="retention-id" type="hidden" v-model="retention.id" />
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group
                        label="Nome:"
                        label-for="retention-name_retention"
                    >
                        <b-form-input
                            id="retention-name_retention"
                            type="text"
                            ref="searchFocus"
                            v-model="retention.name_retention"
                            required
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Nome..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <b-form-group
                        label="Código Retenção:"
                        label-for="retention-code_retention"
                    >
                        <b-form-input
                            id="retention-code_retention"
                            type="text"
                            v-model="retention.code_retention"
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Código..."
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="retention.payment"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="retention-payment"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="retention-payment"
                            >
                                Despesa?
                            </label>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="retention.receipt"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="retention-receipt"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="retention-receipt"
                            >
                                Receita?
                            </label>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="retention.blocked"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="retention-blocked"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="retention-blocked"
                            >
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="retention.account_settlement"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="retention-account_settlement"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="retention-account_settlement"
                            >
                                Fato gerador na Liquidação?
                            </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Tipo de Retenção:"
                        label-for="retention-type_retention_id"
                    >
                        <b-form-select
                            id="retention-type_retention_id"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            size="sm"
                            :options="typeretentions"
                            v-model="retention.type_retention_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="retention.control_advanced"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="retention-control_advanced"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="retention-control_advanced"
                            >
                                Controle Adiantamento?
                            </label>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="retention.account"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="retention-account"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="retention-account"
                            >
                                Contabiliza?
                            </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="5" sm="12">
                    <b-form-group
                        label="Conta Contábil:"
                        label-for="retention-account_plan_id"
                    >
                        <b-form-select
                            id="retention-account_plan_id"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            size="sm"
                            :options="accountplans"
                            v-model="retention.account_plan_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <b-form-group label="Natureza da Conta">
                        <b-form-radio-group
                            v-model="retention.nature_account_plan_retention"
                            :options="options_account"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            name="retention-nature_account_plan_retention"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                    <b-form-group
                        label="Histórico da Conta:"
                        label-for="retention-historic_account"
                    >
                        <b-form-input
                            id="retention-historic_account"
                            type="text"
                            v-model="retention.historic_account"
                            required
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Histórico da Conta..."
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Operação:"
                        label-for="retention-operation_id"
                    >
                        <b-form-select
                            id="retention-operation_id"
                            @input="loadOperationsLevelOnes"
                            size="sm"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            :options="operations"
                            v-model="retention.operation_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="5" sm="12">
                    <b-form-group
                        label="1º Nível:"
                        label-for="retention-operation_level_one_id"
                    >
                        <b-form-select
                            id="retention-operation_level_one_id"
                            @input="loadOperationsLevelTwos"
                            size="sm"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            :options="operationslevelones"
                            v-model="retention.operation_level_one_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="5" sm="12">
                    <b-form-group
                        label="2º Nível:"
                        label-for="retention-operation_level_two_id"
                    >
                        <b-form-select
                            id="retention-operation_level_two_id"
                            size="sm"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            :options="operationsleveltwos"
                            v-model="retention.operation_level_two_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="1" sm="2">
                    <b-form-group label="ID" label-for="entity-id">
                        <b-form-input
                            id="entity-id"
                            type="text"
                            title="ALT+L (Últimos Lançamento) | ALT+ENTER (PESQUISAR)"
                            v-model="retention.entity_retention_id"
                            @input="setEntity()"
                            @change="setEntity"
                            v-on:keyup.alt.enter="openModalEntity"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            size="sm"
                            placeholder="Código..."
                        />
                    </b-form-group>
                </b-col>
                <b-link
                    v-b-modal.modalEntity
                    v-if="!docRead"
                    class="fa fa-search mt-4"
                ></b-link>
                <b-col md="4" sm="8">
                    <b-form-group
                        label="Razão Social:"
                        label-for="entity-name_entity"
                    >
                        <b-form-input
                            id="entity-name_entity"
                            type="text"
                            v-model="entity.name_entity"
                            size="sm"
                            :readonly="true"
                            placeholder="Razão Social..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="2">
                    <b-form-group label="CPF/CNPJ:" label-for="entity-cnpj_cpf">
                        <b-form-input
                            id="entity-cnpj_cpf"
                            type="text"
                            v-model="entity.cnpj_cpf"
                            size="sm"
                            :readonly="true"
                            placeholder=""
                        />
                    </b-form-group>
                </b-col>
                <b-link
                    v-b-modal.modalRegisterEntity
                    v-if="!docRead"
                    class="fa fa-plus mt-4"
                >
                </b-link>
            </b-row>
            <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Tipo de Documento:"
                        label-for="release-type_document_id"
                    >
                        <b-form-select
                            id="retention-type_document_retention_id"
                            size="sm"
                            @input="loadSeries()"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            :options="typedocuments"
                            v-model="retention.type_document_retention_id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Dia de Vencimento:"
                        label-for="retention-duo_day"
                    >
                        <b-form-input
                            id="retention-duo_day"
                            v-model="retention.duo_day"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            type="number"
                            size="sm"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <b-form-group
                        label="Condição:"
                        label-for="retention-condition_duo_retention_id"
                    >
                        <b-form-select
                            id="retention-condition_duo_retention_id"
                            size="sm"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            :options="conditionpaymentreceipts"
                            v-model="retention.condition_duo_retention_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
        <hr v-show="mode === 'save'" />
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2  mb-2 fa fa-plus"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    @click="alterModo"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-save"
                    v-if="mode === 'save'"
                    @click="save"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-trash"
                    v-if="mode === 'remove'"
                    @click="remove"
                >
                </b-button>
                <b-button
                    size="sm"
                    btn-sm
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-reply"
                    v-if="
                        mode === 'remove' || mode === 'save' || mode === 'read'
                    "
                    @click="reset"
                >
                </b-button>
                <b-button
                    size="sm"
                    class="mt-2 mb-2 ml-2 fa"
                    :class="icon"
                    @click="
                        ;[
                            loadRetentions(),
                            toggleBusy(),
                            (showTable = !showTable)
                        ]
                    "
                    variant="dark"
                >
                </b-button>
            </b-col>
        </b-row>
        <br />
        <div class="col-sm-4">
            <div class="form-group">
                <input
                    :busy="isBusy"
                    type="text"
                    size="sm"
                    icon="search"
                    v-model="search"
                    ref="inputsearch"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    placeholder="Informe a descrição"
                    class="form-control"
                />
            </div>
        </div>
        <b-row>
            <b-col md="12" sm="12">
                <transition name="slide" type="animation" appear>
                    <b-table
                        :busy="isBusy"
                        class="table-responsive"
                        :per-page="perPage"
                        :current-page="currentPage"
                        v-show="showTable"
                        hover
                        key="slide"
                        head-variant="light"
                        :items="filteredList"
                        :fields="fields"
                    >
                        <template v-slot:table-busy>
                            <div class="text-center text-info my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Carregando...</strong>
                            </div>
                        </template>
                        <template v-slot:cell(actions)="data">
                            <b-button
                                title="Detalhe do registro"
                                size="sm"
                                variant="light"
                                @click="loadRetention(data.item, 'read')"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-drivers-license-o"></i>
                            </b-button>
                            <b-button
                                title="Editar registro"
                                size="sm"
                                variant="light"
                                @click="loadRetention(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button
                                title="Excluir registro"
                                size="sm"
                                variant="light"
                                @click="loadRetention(data.item, 'remove')"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-trash"></i>
                            </b-button>
                        </template>
                    </b-table>
                </transition>
                <transition name="slide" type="animation" appear>
                    <b-pagination
                        v-show="showTable"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        size="sm"
                        aria-controls="my-table"
                    ></b-pagination>
                </transition>
            </b-col>
        </b-row>
        <b-modal
            id="modalEntity"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Consulta de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="setSearchEntity"
        >
            <EntitySearchModal
                @setEntityId="entity_id = $event"
                @setEntityName="entity.name_entity = $event"
                @setEntityCnpjCpf="entity.cnpj_cpf = $event"
            />
        </b-modal>
        <b-modal
            id="modalRegisterEntity"
            hide-footer
            ref="modal"
            size="xl"
            title-tag="h6"
            title="Registro de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <EntityModal />
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import EntityModal from '../util/EntityModal'
import EntitySearchModal from '../util/EntitySearchModal'
var moment = require('moment')

export default {
    name: 'Retention',
    components: { PageTitle, EntityModal, EntitySearchModal },
    data: function() {
        return {
            mode: 'insert',
            modeParameter: 'insert',
            search: '',
            retention: {},
            entity: {},
            retentions: [],
            retentionsparameter: {},
            retentionsparameters: [],
            typeretentions: [],
            accountplans: [],
            historicalstandards: [],
            conditionpaymentreceipts: [],
            typereleases: [],
            operations: [],
            operationsleveltwos: [],
            operationslevelones: [],
            typedocuments: [],
            showTable: false,
            showTableParameter: false,
            isBusy: false,
            perPage: 5,
            currentPage: 1,
            options_date: [
                { text: 'Data Entrada', value: 0 },
                { text: 'Data Emissão', value: 1 }
            ],
            options_account: [
                { text: 'Crédito', value: 0 },
                { text: 'Débito', value: 1 }
            ],
            fields: [
                { key: 'name_retention', label: 'Nome', sortable: true },
                {
                    key: 'code_retention',
                    label: 'Código Retenção',
                    sortable: false
                },
                {
                    key: 'payment',
                    label: 'Despesa',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                {
                    key: 'receipt',
                    label: 'Receita',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                { key: 'actions', label: 'Ações', variant: 'light' }
            ]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        filteredList() {
            return this.retentions.filter(retention => {
                return retention.name_retention
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.retentions.length
        }
    },
    methods: {
        formatDate(date) {
            return moment.utc(date).format('YYYY-MM-DD')
        },
        async loadRetentions() {
            const url = `${baseApiUrl}/retentions`
            await axios.get(url).then(res => {
                this.retentions = res.data
                this.isBusy = false
            })
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        async reset() {
            this.mode = 'insert'
            await this.loadRetentions()
        },
        alterModo() {
            this.mode = 'save'
            this.retention = {}
        },
        async save() {
            if (this.retention.id) {
                this.retention.user_update_id = this.user.id
                this.retention.update_date = this.formatDate(moment.utc())
            } else {
                this.retention.user_id = this.user.id
            }

            const method = this.retention.id ? 'put' : 'post'
            const id = this.retention.id ? `/${this.retention.id}` : ''
            await axios[method](`${baseApiUrl}/retentions${id}`, this.retention)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        async saveParameter() {
            const method = this.retentionsparameter.id ? 'put' : 'post'
            const id = this.retentionsparameter.id
                ? `/${this.retentionsparameter.id}`
                : ''

            this.retentionsparameter.user_id = this.user.id
            this.retentionsparameter.retention_id = this.retention.id
            await axios[method](
                `${baseApiUrl}/retentionsparameters${id}`,
                this.retentionsparameter
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadRetentionParameters()
                })
                .catch(showError)
        },
        loadRetentionParameters() {
            const url = `${baseApiUrl}/retentionsparameters/${this.retention.id}/retention`
            axios.get(url).then(res => {
                this.retentionsparameters = res.data
            })
        },
        loadRetentionParameter(retentionparameter) {
            this.retentionparameter = { ...retentionparameter }
        },
        async setParameter(retention) {
            this.retention = { ...retention }
            this.retentionsparameter = {}
            await this.loadRetentionParameters()
            this.showTableParameter = true
        },
        async remove() {
            const id = this.retention.id
            await axios
                .delete(`${baseApiUrl}/retentions/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        loadTypeRetention() {
            const url = `${baseApiUrl}/typeretentions`
            axios.get(url).then(res => {
                this.typeretentions = res.data.map(typeretention => {
                    return {
                        value: typeretention.id,
                        text: typeretention.name_type_retention
                    }
                })
            })
        },
        loadAccountPlan() {
            const url = `${baseApiUrl}/accountplananalitic`
            axios.get(url).then(res => {
                this.accountplans = res.data.map(accountplan => {
                    return {
                        value: accountplan.id,
                        text: `${accountplan.internal_code_account_plan} - ${accountplan.name_account_plan} `
                    }
                })
            })
        },
        loadTypeRelease() {
            const url = `${baseApiUrl}/typereleases`
            axios.get(url).then(res => {
                this.typereleases = res.data.map(typerelease => {
                    return {
                        value: typerelease.id,
                        text: typerelease.name_type_release
                    }
                })
            })

            this.$refs.inputsearch.focus()
        },
        loadRetention(retention, mode = 'save') {
            this.$refs.searchFocus.focus()
            this.mode = mode
            this.retention = { ...retention }
        },
        async loadHistoricalStandard() {
            const url = `${baseApiUrl}/historicalstandards`
            await axios.get(url).then(res => {
                this.historicalstandards = res.data.map(historicalstandard => {
                    return {
                        value: historicalstandard.id,
                        text: historicalstandard.name_historical
                    }
                })
            })
        },
        async loadOperation() {
            const url = `${baseApiUrl}/operations`
            await axios.get(url).then(res => {
                this.operations = res.data.map(operation => {
                    return {
                        value: operation.id,
                        text: operation.name_operation
                    }
                })
            })
        },
        async loadOperationsLevelOnes() {
            const url = `${baseApiUrl}/operationslevelones/${this.retention.operation_id}/operations`
            await axios.get(url).then(res => {
                this.operationslevelones = res.data.map(operationslevelone => {
                    return {
                        value: operationslevelone.id,
                        text: operationslevelone.name_operation_level_one
                    }
                })
            })
        },
        async loadOperationsLevelTwos() {
            const url = `${baseApiUrl}/operationsleveltwos/${this.retention.operation_level_one_id}/operationslevelones`
            await axios.get(url).then(res => {
                this.operationsleveltwos = res.data.map(operationsleveltwo => {
                    return {
                        value: operationsleveltwo.id,
                        text: operationsleveltwo.name_operation_level_two
                    }
                })
            })
        },
        async removeParameter() {
            const id = this.retentionsparameter.id
            await axios
                .delete(`${baseApiUrl}/retentionsparameters/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadRetentionParameters()
                })
                .catch(showError)
        },
        async actionNewParameter(retention) {
            this.retention = { ...retention }
            this.retentionsparameter = {}
            await this.loadRetentionParameters()
            this.showTableParameter = true
        },
        loadTypeDocument() {
            const url = `${baseApiUrl}/typedocumentsbyguides`
            axios.get(url).then(res => {
                this.typedocuments = res.data.map(typedocument => {
                    return {
                        value: typedocument.id,
                        text: typedocument.name_reduced
                    }
                })
            })
        },
        openModalEntity() {
            this.$bvModal.show('modalEntity')
        },
        async setEntity(entity) {
            if (!this.retention.entity_retention_id) {
                this.retention.entity_retention_id = entity.id
            }

            const url = `${baseApiUrl}/entitys/${this.retention.entity_retention_id}`
            await axios(url).then(res => (this.entity = res.data))
        },
        setSearchEntity() {
            this.retention = {
                ...this.retention,
                entity_retention_id: this.entity_id
            }
        },
        focusSearch() {
            this.$refs.inputsearch.focus()
        },
        loadConditionPaymentReceipt() {
            const url = `${baseApiUrl}/conditionpaymentreceipts`
            axios.get(url).then(res => {
                this.conditionpaymentreceipts = res.data.map(
                    conditionpaymentreceipt => {
                        return {
                            value: conditionpaymentreceipt.id,
                            text:
                                conditionpaymentreceipt.name_condition_payment_receipt
                        }
                    }
                )
            })
        }
    },
    mounted() {
        this.loadTypeRetention()
        this.loadAccountPlan()
        this.loadHistoricalStandard()
        this.loadTypeRelease()
        this.loadRetentions()
        this.loadOperation()
        this.loadTypeDocument()
        this.loadConditionPaymentReceipt()
        this.showTable = true
    }
}
</script>

<style>
.retention {
    font-size: 0.7rem;
}

.retention input,
label,
form {
    font-size: 0.7rem;
}
.retention button {
    font-size: 0.7rem;
}

.retention select {
    font-size: 0.7rem;
}

.retention table {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
